var map = {
	"./AMEX_LOCAL.svg": "1ef8",
	"./CUP_LOCAL.svg": "ce4a",
	"./DCI_LOCAL.svg": "4815",
	"./DXNEXTPAY.svg": "8776",
	"./JCB_LOCAL.svg": "66a6",
	"./MASTER_LOCAL.svg": "100c",
	"./NAPASCREDIT.svg": "0e19",
	"./UNIONPAY.svg": "2918",
	"./VISA_LOCAL.svg": "aa1e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "92f7";